
    <app-header></app-header>
    <app-chatbot></app-chatbot>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
    <app-cookies></app-cookies>

